import { RiskIndicatorImpactModel } from './RiskIndicatorImpactModel';
import { RiskScenarioSimulationModel } from './RiskScenarioSimulation';

export type RiskModel = {
	id: string;
	name: string;
	description: string;
	impact: number;
	likelihood: number;
	mitigation: string;
	createdAt: Date;
	updatedAt: Date;
	scenarios: RiskScenarioSimulationModel[];

	impactedIndicators: RiskIndicatorImpactModel[];
};

export const defaults = {
	__typename: 'Risk',
	name: '',
	description: '',
	reference: '',
	impact: 1,
	likelihood: 1,
	riskCategoryId: '',
	matchingOpportunityId: '',
	isOpportunity: false,
	evaluatedAt: '',
	scenarios: [],
	taggings: [],
	impactedIndicators: [],
	createdAt: new Date()
};
